module.exports = __webpack_public_path__ + "static/media/okwash2.e4484bd9.png";